<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-24 14:20:31
 * @Description: file content
 -->
 <template>
  <div class="mymodal" v-show="value">
    <div class="info">
      <div class="info-title"></div>
      <div class="fare">
        <div class="title-kj">赛事提醒</div>
        <div class="content-wz"></div>
        <div class="content-wz">
          竞猜活动开始后，将通过短信通知您，请注意查收
        </div>
        <div v-if="!this.$util.cookie.get('mobile')" class="input_txt">
          <div class="input_phone">
            <input
              @blur="blurInput"
              v-model="mobile"
              type="tel"
              placeholder="手机号码"
            />
          </div>
        </div>
        <div v-if="!this.$util.cookie.get('mobile')" class="input_code">
          <div class="left">
            <input
              @blur="blurInput"
              v-model="vcode"
              type="number"
              placeholder="验证码"
              oninput="if(value.length>6)value=value.slice(0,6)"
            />
          </div>
          <div class="right">
            <div @click="clickCode" v-if="!showVcode">{{ VerShowTxt }}</div>
            <div v-else>{{ counts }}s</div>
          </div>
        </div>
        <div class="btn" @click="onConfirm">确认</div>
      </div>
      <div class="botBtn" @click="closeMask">
        <img
          src="http://assets.rurushishi.com/activies/panda-game/close.png"
          alt
        />
      </div>
      <!-- <div class="botBtn" @click="closeMask">再接再厉</div> -->
    </div>
  </div>
</template>
    
  <script>
  import Vue from "vue/dist/vue.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      value: false,
      callback: null,
      userInfo: {},
      mobile: "",
      vcode: "",
      showVcode: false,
      counts: 60,
      getVcodes: "获取验证码",
      sessionId: "",
      IsCanVer: true, //是否能发送验证码
      VerShowSec: 60, //读秒
      VerShowTxt: "获取验证码",
      ismobile: 0, //1 有电话、0 没电话
    };
  },

  methods: {
    closeMask() {
      this.value = false;
      console.log("dianjil");
      //   this.callback("ranking");
    },
    getMask() {
      this.value = true;
    },
    // async getUserInfo() {
    //   const data = await this.$httpdf.get(this.apiHost + "fc/myInfo");
    //   if (data.code == 0) {
    //     console.log(data, "====");
    //     this.userInfo = data.data;
    //   }
    // },
    // 点击获取验证码
    clickCode() {
      if (this.IsCanVer) {
        var mobile = this.mobile;
        if (mobile.length == 0) {
          this.$showModal("请输入手机号！");
        } else if (!this.$util.isMobile(mobile)) {
          this.$showModal("请输入正确的手机号！");
        } else {
          console.log("我到这里了");
          this.IsCanVer = false;
          this.VerShowTxt = this.VerShowSec + "s";
          this.VerShowSec--;
          setInterval(() => {
            if (this.IsCanVer == false) {
              if (this.VerShowSec == 0) {
                this.VerShowTxt = "获取验证码";
                this.IsCanVer = true;
                this.VerShowSec = 60;
              } else {
                this.VerShowTxt = this.VerShowSec + "s";
                this.VerShowSec--;
              }
            }
          }, 1000);

          this.$httpdf
            .get(this.apiHost + "fc/sendSmsCode" + "?mobile=" + this.mobile)
            .then((data) => {
              if (data.code == 0) this.$showModal("验证码已发送到您的手机！");
              else this.$showModal(data.msg);
            });
        }
      }
    },
    blurInput() {},
    async onConfirm() {
      let ihop = this.$util.cookie.get("mobile");
      if (ihop) {
        const data = await this.$httpdf.get(
          this.apiHost +
            "fc/matchReminder" +
            "?sessionId=" +
            sessionStorage.getItem("sessionId")
        );
        if (data.code == 0) {
          this.$showModal("赛事订阅成功");
          this.value = false;
          this.$emit("fMethod");
        }else{
          this.$showModal(data.msg)
        }
      } else {
        const data = await this.$httpdf.get(
          this.apiHost +
            "fc/matchReminder" +
            "?mobile=" +
            this.mobile +
            "&code=" +
            this.vcode +
            "&sessionId=" +
            sessionStorage.getItem("sessionId")
        );
        if (data.code == 0) {
          this.$showModal("赛事订阅成功");
          Vue.prototype.$mobile = this.mobile;
          this.$util.cookie.set("mobile", this.$mobile, {
            expires: 60,
          });
          this.value = false;
          this.$emit("fMethod");
        }else{
          this.$showModal(data.msg)
        }
      }
    },
    // let text = {
    //     text1: "点击",
    //     text2: "右上角",
    //     text3: "推荐好友参与",
    //     text4: "让你和TA都获得金喜，",
    //     text5: "快去消息列表看看",
    //     text6: "会有什么神奇的事情发生吧！",
    //   };
    //   this.$modal.share.alert(text).then((res) => {
    //     if (res == "onSave") {
    //       this.$goPage("poster");
    //     }
    //   });
    // },
  },
  created() {
    this.mobile = this.$util.cookie.get("mobile") || "";
    // this.getUserInfo()
  },
  mounted() {},
};
</script>
    
    
    <style lang="scss" scoped>
.banner {
  padding-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 100;
}

.info {
  width: 265px;
  background: #fff;
  border-radius: 10px;
  padding: 0 20px 20px;
  box-sizing: border-box;
  position: relative;
  .info-title {
    width: 265px;
    height: 106px;
    position: absolute;
    left: 50%;
    top: -100px;
    background: url($imgHost + "tanc.png") center / 100% no-repeat;
    transform: translateX(-50%);
  }
  .fare {
    font-size: 15px;
    font-family: PingFangSC;
    font-weight: 400;

    // color: #2d89fb;
    // text-align: center;
    // line-height: 130%;
    .title-kj {
      padding: 15px 0;
      text-align: center;
      font-size: 18px;
      color: #000;
    }
    .content-wz {
      font-size: 12px;
      color: #666666;
      line-height: 18px;
      margin-bottom: 10px;
    }
    .input_txt {
      margin-bottom: 10px;
    }
    .input_txt,
    .input_code {
      input {
        background-color: #f6f6f9;
        width: 100%;
        height: 28px;
      }
    }
    .input_code {
      display: flex;
      margin-bottom: 10px;
      .right {
        width: 90px;
        border: 1px solid #36841b;
        margin-left: 10px;
        color: #36841b;
        text-align: center;
        line-height: 28px;
        border-radius: 5px;
        // line-height: 60px;
      }
      .left {
        flex: 1;
      }
    }
  }
  .btn {
    width: 100%;
    height: 44px;
    border-radius: 22px;
    text-align: center;
    line-height: 44px;
    background-color: #fdb43a;
  }
  .botBtn {
    position: absolute;
    left: 50%;
    top: 110%;
    transform: translateX(-50%);
    // width: 140px;
    // height: 39px;
    // line-height: 39px;
    // background: #6488f7;
    // border-radius: 20px;
    // font-size: 18px;
    // font-family: PingFangSC;
    // font-weight: 500;
    // color: #ffffff;
    // text-align: center;
    width: 20px;
    height: 20px;
  }
}
.sclose {
  position: absolute;
  top: -60px;
  right: -11px;
  width: 20px;
  height: 20px;
}

.msgbox {
  background-image: url("https://yqweb.oss-cn-shanghai.aliyuncs.com/activies/floppy-bird/get_more.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  width: 321px;
  height: 317px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    font-size: 19px;
    font-family: FZHZGBJW;
    font-weight: bold;
    color: rgba(102, 102, 102, 1);
  }
}

.msgbox .title {
  font-size: 16px;
  font-family: PingFang SC;
  color: #ffffff;
  background-color: #e82f1c;
  min-height: 45px;
  line-height: 45px;
  text-align: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.msgbox .content {
  width: 90%;
  margin: 0 auto;
  text-align: center;
}

.msgbox .content .tip1 {
  padding-top: 5px;
  line-height: 27px;
  font-size: 16px;
  font-family: PingFang SC;
  color: #e72b1a;
}

.msgbox .content .tip2 {
  padding-top: 5px;
  line-height: 20px;
  font-size: 12px;
  font-family: PingFang SC;
  color: rgba(51, 51, 51, 1);
}

.msgbox .content input {
  border-radius: 3px;
  width: 100%;
  height: 37px;
  text-indent: 15px;
  color: #666666;
  background: rgba(237, 237, 237, 1);
}

.msgbox .content .input_txt {
  width: 100%;
  margin: 12px auto 0 auto;
}

.msgbox .content .input_code {
  width: 100%;
  margin: 12px auto 0 auto;
  display: flex;
}

.msgbox .content .input_code .left {
  width: 55%;
}

.msgbox .content .input_code .right {
  width: 45%;
}

.msgbox .content .input_code .right > div {
  border-radius: 6px;
  width: 90%;
  margin-left: 10%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #ffffff;
  color: rgba(233, 48, 26, 1);
}

.msgbox .btns {
  height: 40px;
  display: flex;
  justify-content: center;
  margin: 12px auto 0 auto;
}

.msgbox .btns > div {
  width: 35%;
}

.msgbox .close {
  position: absolute;
  top: -26px;
  right: -26px;
  width: 24px;
  height: 24px;
  z-index: 1001;
}

.address_detail {
  line-height: 20px;
  font-size: 12px;
  font-family: PingFang SC;
  color: rgba(51, 51, 51, 1);
  text-align: justify;
}

.checkrank {
  width: 280px;
  height: 48px;
  margin-top: 6px;

  img {
    width: 100%;
    height: 100%;
  }
}

.gameagain {
  width: 197px;
  height: 60px;
  padding-top: 14px;
  position: relative;
  z-index: 2000;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>